import React, { useEffect, useState } from "react";
import { Input, Modal } from "antd";
import { getWindowHeight, matchesSearchText } from "../../../services";
import MultiSelectFooter from "./MultiSelectFooter";
import MultiSelectContent from "./MultiSelectContent";
import MultiSelectHeader from "./MultiSelectHeader";

const MaxItem = 5;
const ItemHeight = 50;
const ButtonHeight = 32;
const FilterBoxHeight = 32;
const Padding = 65;
const ModalBodyStyle = { paddingBottom: 20, paddingTop: 12 };

const MultiSelectModal = props => {
  const { value, visible, onCancel, options, groups, title } = props;
  const windowHeight = getWindowHeight();

  const [visibleOptions, setVisibleOptions] = useState([]);
  const [visibleGroups, setVisibleGroups] = useState([]);
  const [optionValues, setOptionValues] = useState([]);

  // Initialize optionValues from value prop when modal opens
  useEffect(() => {
    if (visible) {
      setOptionValues(value || []);
    }
  }, [visible, value]);

  useEffect(() => {
    setVisibleOptions(options);
    if (groups) {
      setVisibleGroups(groups);
    }
  }, [options, groups]);

  const getTotalOptionsCount = () => {
    if (groups) {
      return groups.reduce((acc, g) => acc + g.options.length, 0);
    }
    return options.length;
  };

  const handleFilterChange = e => {
    const { options, groups } = props;
    const { value } = e.target;

    if (groups) {
      const filteredGroups = groups
        .map(group => ({
          ...group,
          options: group.options.filter(o => matchesSearchText(value, o.title))
        }))
        .filter(group => group.options.length > 0);
      setVisibleGroups(filteredGroups);
    } else {
      const filteredOptions = options.filter(o => matchesSearchText(value, o.title));
      setVisibleOptions(filteredOptions);
    }
  };

  // Get all currently visible option values
  const getVisibleOptionValues = () => {
    if (groups) {
      const values = [];
      visibleGroups.forEach(group => {
        group.options.forEach(opt => values.push(opt.value));
      });
      return values;
    }
    return visibleOptions.map(opt => opt.value);
  };

  const handleChange = newValues => {
    // Get currently visible options
    const visibleValues = getVisibleOptionValues();

    // Keep selections that are NOT in visible options (preserved from filtering)
    const preservedValues = optionValues.filter(v => !visibleValues.includes(v));

    // Merge preserved values with new selections from visible options
    setOptionValues([...preservedValues, ...newValues]);
  };

  const handleCancel = () => {
    setVisibleOptions(options);
    if (groups) {
      setVisibleGroups(groups);
    }
    onCancel();
  }

  const handleOk = () => {
    const { onOk, onCancel } = props;
    onOk(optionValues);

    //reset visible options
    setVisibleOptions(options);
    if (groups) {
      setVisibleGroups(groups);
    }
    //close modal
    onCancel();
  };

  const totalCount = getTotalOptionsCount();

  return (
    visible && (
      <Modal
        destroyOnClose
        closable={false}
        onCancel={onCancel}
        footer={null}
        visible={visible}
        style={{
          paddingBottom: 0,
          paddingTop: 0,
          marginBottom: 0,
          marginTop: 0,
          top:
            totalCount > MaxItem
              ? (windowHeight -
                MaxItem * ItemHeight -
                ButtonHeight -
                FilterBoxHeight) /
              2 -
              Padding
              : (windowHeight - totalCount * ItemHeight - ButtonHeight) / 2 -
              Padding
        }}
        bodyStyle={ModalBodyStyle}
      >
        <MultiSelectHeader title={title} onCancel={onCancel} />
        {totalCount > MaxItem ? (
          <Input.Search
            onChange={handleFilterChange}
            placeholder={"Traži"}
          />
        ) : null}
        <MultiSelectContent
          value={optionValues}
          style={{ maxHeight: MaxItem * ItemHeight }}
          onChange={handleChange}
          options={visibleOptions}
          groups={groups ? visibleGroups : null}
        />
        <MultiSelectFooter onCancel={handleCancel} onOk={handleOk} />
      </Modal>
    )
  );
};

MultiSelectModal.defaultProps = {
  visible: false,
  value: [],
  title: ""
};

export default MultiSelectModal;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiSelectModal/index.tsx